import appboyService from 'services/appboy';

analyticsService.$inject = [
  '$location',
  '$rootScope',
  'jsSdk.auth',
  'segment',
  'jsSdk.managementUser',
  'organizationService'
];

export default function analyticsService($location, $rootScope, authService, segment, managementUserService, organizationService) {
  /**
   * @module AnalyticsService
   */
  class AnalyticsService {

    /**
     * Initialize service
     * - setup state change listeners
     * - setup user change listeners
     */
    init() {
      this.ready = false;
      setupStateChangeListener();
      setupLogoutListeners();
    }

    /**
     * Track the currently logged in user
     */
    identifyUser() { //eslint-disable-line
      const currentUser = managementUserService.getCurrentUser();
      if (!currentUser) throw new Error('identifyUser() - no current user');

      const userData = {
        name: currentUser.name,
        firstName: currentUser.firstName,
        lastName: currentUser.lastName,
        phone: currentUser.phone,
        email: currentUser.email,
        createdAt: currentUser.created ? new Date(currentUser.created).toISOString() : null
      };

      appboyService.resumeWebTracking();

      appboyService.init();

      appboyService.identify(currentUser);

      segment.identify(currentUser.id, userData);

      if (window.wrkflows) {
        window.wrkflows.identify(currentUser.id, userData);
      }
    }

    /**
     * Track the currently set organiztion
     */
    identifyOrganization() { //eslint-disable-line
      identifyOrganization();
    }

    /**
     * Track the current page view
     *
     * @private
     */
    trackPageView() { //eslint-disable-line
      trackPageView();
    }

    /**
     * Track an event
     *
     * @param {string} name - event name
     * @param {Object} [data] - event data
     */
    trackEvent(eventName, data = {}) { //eslint-disable-line
      if (!eventName) throw new Error('eventName');

      const currentUserOrganization = organizationService.getCurrentOrganization();

      if (currentUserOrganization) {
        data.organizationId = currentUserOrganization.id;
        data.organizationName = currentUserOrganization.name;
      }

      console.log('TRACK EVENT', eventName);

      appboyService.track(eventName, data);

      segment.track(eventName, data);
    }

    onReady(callback) { //eslint-disable-line
      if (this.ready) return callback();

      segment.ready(() => {
        this.ready = true;
        callback();
      });
    }
  }

  /* =========================================================================
   * Private
   * ========================================================================= */

  /**
   * Track the current page view
   *
   * @private
   */
  function trackPageView() {
    // https://community.segment.com/t/368abk/angular-event-tracking

    const path = $location.path();
    const url = $location.absUrl();
    let query = '';

    // Check for query string
    if (url.indexOf('?') !== -1) {
      query = url.substring(url.indexOf('?'), url.length);
    }

    const data = {
      url: url,
      query: query,
      path: path
    };

    const currentUserOrganization = organizationService.getCurrentOrganization();

    if (currentUserOrganization) {
      data.organizationId = currentUserOrganization.id;
      data.organizationName = currentUserOrganization.name;
    }

    segment.page(data);
  }

  function identifyOrganization() {
    const currentUserOrganization = organizationService.getCurrentOrganization();
    if (!currentUserOrganization) throw new Error('identifyOrganization() - no current organization');

    segment.group(currentUserOrganization.id, {
      name: currentUserOrganization.name,
      address: currentUserOrganization.address,
      city: currentUserOrganization.city,
      state: currentUserOrganization.state,
      zip: currentUserOrganization.zip,
      type: currentUserOrganization.type,
      status: currentUserOrganization.status,
      isVenueOwner: currentUserOrganization.isVenueOwner,
      isPaying: currentUserOrganization.isPaying,
      createdAt: currentUserOrganization.created ? new Date(currentUserOrganization.created).toISOString() : null
    });
  }

  function clearUser() {
    segment.reset();

    if (window.wrkflows) window.wrkflows.reset();
  }

  function setupLogoutListeners() {
    authService.on(authService.EVENTS.MANAGEMENT_LOGGED_OUT, function() {
      clearUser();
    });
  }

  function setupStateChangeListener() {
    $rootScope.$on('$stateChangeSuccess', () => {
      trackPageView();
    });
  }

  return new AnalyticsService();
}



// WEBPACK FOOTER //
// ./src/services/analyticsService.js